import React, { useEffect, useState } from 'react';
import { useAuthState } from "react-firebase-hooks/auth";
//import { database } from "./firebase";
import { auth,database ,logout} from "./firebase";
import { getDatabase, ref, child, get,remove } from "firebase/database";
import { useNavigate } from "react-router-dom";
import { reload } from 'firebase/auth';
import DateTime from './DateTime';

import "./i18n";
import { useTranslation } from "react-i18next";
import Iframe from 'react-iframe'
import { set } from 'mongoose';


const db = getDatabase();




const FirebaseDBFileList2 = (props) => {
  const [datas, setDatas] = useState([]);
  const [months , setMonths ] = useState([]);

  //const [user, setUser] = useState('');
  const [age, setAge] = useState('');
  const [num,setNum] = useState(0)
  
  const [size,setSize] = useState(0)

  //const userRef = database.ref('users');
  const userRef = ref(db);

  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();

  const [selectedMonth, setSelectedMonth] = useState("");
 
 

  // console.log("test1");
  // console.log("test" + params);
  // console.log("test1");
//  const [searchParams] = useSearchParams();

  

  const getMonthFromDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${year}-${month}`;
  }

  useEffect(() => {

    //console.log({lang: searchParams.get('id')}) 
    
    console.log("sdfsdfsd") 

    // userRef.on('value', snapshot => {
    //   const users = snapshot.val();
    //   const usersData = [];
    //   for(let id in users) {
    //     usersData.push({ ...users[id], id });
    //   }
  
    //   setDatas(usersData);
    // })

    if (loading) return;
    
    
    //if (!user) return navigate("/");

    var count = 0 

    console.log(`share/${props.deviceID}/urls`);
    
    //get(child(userRef, `share/${props.uid}/${props.deviceID}/files`)).then((snapshot) => {
    get(child(userRef, `share/${props.deviceID}/urls`)).then((snapshot) => {
      if (snapshot.exists()) {
        console.log(snapshot.val());
        const usersData = [];

        //setNum ( snapshot.count() )
        var total = 0
        var months = []
        snapshot.forEach(function(d) {
          
          //setNum ( num +1 )
          count++
          
          const data = {key:d.key, user:d.val().deviceName ,
            state : 'offline',
            roomID:d.val().name,
            startDateTime:d.val().startDateTime,
            updateDateTime:d.val().updateDateTime,
            title:d.val().title,
            url: d.val().url,
            count : count,
            isEvent : d.val().isEvent,
            size : d.val().size,
          };

          var now = new Date()
          var update = new Date(d.val().updateDateTime)

          
          var month = getMonthFromDate(d.val().updateDateTime);
          if (!months.includes(month)) {
            months.push(month);

            
          }

          update.setSeconds(update.getSeconds() + 65)
          console.log(update);

          if( now < update ){
            data.state = "online"
          }

          // if( d.val().roomID != "0"){
          //   data.state = "online"
          // }
          if( data.size!= null)
            total += data.size
          //setSize(size +  data.size)
          usersData.push(data);

        })
        
        usersData.sort((a, b) => new Date(b.updateDateTime) - new Date(a.updateDateTime));

        months.sort((a, b) => b.localeCompare(a));
        
        if (months.length > 0) {
          setSelectedMonth( months[0] )
        }

        setMonths( months);

        setSize(total)

        for(let d in snapshot.val()) {
        }
        
        setDatas(usersData);

      } else {
        console.log("No data available");
      }
    }).catch((error) => {
      
      console.log(user?.uid);
      console.error(error);
    });

    
  }, [user, loading]);

  const onChange = (e) => {
    //e.target.name === 'user' ? setUser(e.target.value) : setAge(e.target.value);
  }

  const onClickAdd = () => {
    const userData = { user, age };

    userRef.push(userData);
    //setUser('');
    setAge('');
  }

  const onClickRemove = (id) => {
    
    remove(child(userRef, `users/${user?.uid}/items/${id}`))

    setDatas( datas.filter(el => el.key != id));
    //child(userRef, `users/${user?.uid}/items/${id}`).remove();
    //remove(ref(db, `users/${user?.uid}/items/${id}`))
    //userRef.child(id).remove();


  }

  function refreshPage() {
    window.location.reload(false);
  }
  

  const onUpdate = (id) => {
    const [user] = datas.filter(el => el.id === id);

    userRef.child(id).update({
      age: user.age++
    });

    setDatas(datas.map(el => el.id === id ? {...el, age: el.age++} : el));
  };

  const { t, i18n } = useTranslation();


  const handleOpenNewTab = (url) => {
    // window.open(url, "_blank", "noopener, noreferrer");
  };


  return (
    <div >
      <div>
        Files : {datas.length} unit

       Size : {size /1024 } GB
            
        
      </div>

      <div>
        <label htmlFor="month-select">Month: </label>
        <select id="month-select" onChange={(e) => {
          
            setSelectedMonth(e.target.value);
          }}>
            
            {months.map(month => (
            <option key={month} value={month}>
              {month}월
            </option>
            ))}
          </select>
          </div>

          

          {datas?.map(data => (
          <card key={data.id}>
            { getMonthFromDate(data.updateDateTime) !== selectedMonth ? null : (
            <>
              
              <br/>
              Date : {data.updateDateTime}<br/>

              Filename : {data.url}

              <button onClick={() => {
                  const updatedDatas = datas.map(item => 
                    item.key === data.key ? {...item, isView: !item.isView} : item
                  );
                  setDatas(updatedDatas);
              }}
                >
              view
              </button>



              <br/>
              {data.isView &&
                <iframe
                  width="560"
                  height="315"
                  src={"https://www.youtube.com/embed/"+data.url}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  ></iframe>
              }
              {/* {data.count % 2 === 0 && <br/>} */}
            </>
          )}
        </card>
      ))}

      {/* <input onChange={onChange} name='user' placeholder='user' value={user}></input>
      <input onChange={onChange} name='age' placeholder='age' value={age}></input>
      <button onClick={onClickAdd}>추가하기</button> */}

        {/* <button className="dashboard__btn" onClick={refreshPage}>
          Page Refresh(화면갱신)
        </button> */}


<br />
<br />

      

    </div>
  );
};

//export default FirebaseDB;
export {FirebaseDBFileList2};